import * as React from "react";

import {
  VeteranAutoProductPriceFormValues,
  VeteranAutoTexts,
} from "../veteranAutoInterface";

import { PaddedSurface as Surface } from "App/global-style";
import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";

interface Props {
  readonly formProps: FormikProps<VeteranAutoProductPriceFormValues>;
  readonly updatePrices: (isMemberOfVeteranClub: BooleanFormType) => void;
  readonly texts: VeteranAutoTexts;
  readonly lang: TextLanguage;
}

export const FormElements = (props: Props): JSX.Element => {
  const { formProps, updatePrices, texts, lang } = props;
  const formTexts = texts.formText.checkPrice;

  return (
    <Surface>
      <RadioButtonTrueFalse
        name="isMemberOfVeteranClub"
        id="isMemberOfVeteranClub"
        label={formTexts.isMemberOfVeteranClub.label[lang]}
        hint={formTexts.isMemberOfVeteranClub.hint?.[lang]}
        options={[
          {
            label: formTexts.isMemberOfVeteranClub.options.yes[lang],
            value: true,
            id: "is-member-of-veteran-club",
          },
          {
            label: formTexts.isMemberOfVeteranClub.options.no[lang],
            value: false,
            id: "is-not-member-of-veteran-club",
          },
        ]}
        direction="vertical"
        onChange={(e) => updatePrices(e.target.value as BooleanFormType)}
        error={getError("isMemberOfVeteranClub", formProps)}
      />
    </Surface>
  );
};
